<template>
  <section class='section'>
    <modalAddUsers
      v-if="addUserModal"
      :active="addUserModal"
      :action="createUserAdminLocal"
      :close="closeAddUserModal"
    />
    <modalEditAdministrator
      v-if="modalEditAdmin"
      :action="editAdmin"
      :close="closeEditAdministrator"
      :name="nameAdmin"
      :status="statusAdmin"
      :rolId="rolIdAdmin"
    />
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <h1>Administradores</h1>
        </div>
      </div>
      <div class="level-left">
      </div>
      <div class="level-right">
        <div class="level-item">
          <div class="control">
            <button
              class="button"
              type="button"
              :class="{ 'is-loading': isLoading }"
              @click="getCsvDownload"
            >
              Descargar
            </button>
          </div>
        </div>
        <div class="level-item">
          <div class="control has-text-centered-mobile">
            <div
              class="button has-text-centered-mobile button-givu"
              @click="showAddUserModal"
            >
              Agregar Administrador
            </div>
          </div>
        </div>
      </div>
    </nav>
    <div class="columns is-multiline">
      <div class="column is-12">
        <base-table
          class="is-bordered is-striped is-narrow is-fullwidth is-hoverable bankingTable"
          :columns="columnsData"
          :data="adminList"
          :loading=loading
        >
        <div
          slot="config"
          slot-scope="scope"
        >
          <i class="material-icons icon-action" @click="openEditAdmin(scope.row)">edit</i>
        </div>
        </base-table>
      </div>
    </div>
    <base-pagination
      class="is-medium"
      :page="page"
      :pages="parseInt(pages)"
      :action="paginator"
      :loading="loading"
    />
  </section>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'

const DEFAULT_DISPLAY_SIZE = 10

export default {
  name: 'Productos',
  components: {
    BaseTable: () => import('@/components/Table'),
    BasePagination: () => import('@/components/BasePagination'),
    ModalAddUsers: () => import('@/components/admin/Modal.vue'),
    ModalEditAdministrator: () => import('@/components/admin/ModalEditAdministrator.vue')
  },
  data () {
    return {
      addUserModal: false,
      modalEditAdmin: false,
      page: 1,
      pages: '',
      loading: false,
      isLoading: false,
      adminList: [],
      columnsData: [
        { id: 'id', header: 'Id', class: 'column-mobile' },
        { id: 'name',
          header: 'Nombre',
          class: 'column-mobile'
        },
        { id: 'email', header: 'E-mail', class: 'column-mobile' },
        {
          id: 'status',
          header: 'Bloqueado',
          accessor: (row) => row.blocked ? 'Si' : 'No'
        },
        { id: 'config', name: 'config', header: 'Acciones', class: 'column-mobile has-text-centered' }
      ],
      idAdmin: 0,
      statusAdmin: false,
      rolIdAdmin: 0,
      nameAdmin: null
    }
  },
  methods: {
    ...mapMutations(['setAuthenticationValue']),
    ...mapActions(['getAdminUsers', 'createUserAdmin', 'adminUpdate', 'csvDownloadAdminUser', 'addTemporalNotification']),
    editAdmin (data) {
      let dataUpdate = {
        ...data,
        id: this.idAdmin
      }
      this.adminUpdate(dataUpdate)
        .then((resp) => {
          if (resp) {
            this.getAdminUsers({ page: 1 })
              .then(resp => {
                this.adminList = resp.payload
                this.pages = resp.totalPages
              })
            this.modalEditAdmin = false
          }
          this.loading = false
        })
    },
    paginator (page) {
      this.page = page
      this.loading = true
      this.getAdminUsers({ page })
        .then(resp => {
          this.loading = false
          this.adminList = resp.payload
          this.pages = resp.totalPages
        })
    },
    showAddUserModal () {
      this.addUserModal = true
    },
    closeAddUserModal () {
      this.addUserModal = false
    },
    openEditAdmin (data) {
      this.idAdmin = data.id
      this.statusAdmin = data.blocked
      this.rolIdAdmin = data.rol_id
      this.nameAdmin = data.name
      this.modalEditAdmin = true
    },
    closeEditAdministrator () {
      this.modalEditAdmin = false
    },
    async createUserAdminLocal (data) {
      let newUser = await this.createUserAdmin(data)
      if (newUser) {
        let adminList = await this.getAdminUsers({ page: 1 })
        this.adminList = adminList.payload
        this.pages = adminList.totalPages
        this.addUserModal = false
      }
      this.loading = false
    },
    getCsvDownload () {
      this.isLoading = true
      this.csvDownloadAdminUser()
        .then(resp => {
          if (resp) {
            const exportName = 'Export administrators.csv'
            const blob = new Blob([resp], { type: 'text/csv;charset=utf-8;' })
            if (navigator.msSaveBlob) {
              navigator.msSaveBlob(blob, exportName)
            } else {
              const link = document.createElement('a')
              if (link.download !== undefined) {
                const url = URL.createObjectURL(blob)
                link.setAttribute('href', url)
                link.setAttribute('download', exportName)
                link.style.visibility = 'hidden'
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
              }
            }
          } else {
            this.addTemporalNotification({ type: 'danger', message: 'Error en la descarga' })
          }
          this.isLoading = false
        })
    }
  },
  beforeMount () {
    this.loading = true
    this.getAdminUsers({ page: this.page, size: DEFAULT_DISPLAY_SIZE })
      .then(resp => {
        this.adminList = resp.payload
        this.pages = resp.totalPages
        this.loading = false
      })
  }
}
</script>
<style scoped>
  .section {
    width: 100%;
    padding: 0 20px 0 20px;
  }
  .icon-action {
    cursor: pointer;
    color: #039DA1;
    font-size: 14px;
  }

  .icon-action:hover {
    color: var(--primary-color);
  }
</style>
